import { Icon } from "@iconify/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import Common from "../../../helper/common";
import { useAuth } from "../../../contexts/auth/authContext";
import common from "../../../helper/common";
import { useNavigate, Link } from "react-router-dom";
import Utility from "../../../helper/utilityHelper";
import avatarImg from "../../../assets/images/logo/avatarImg.jpg";
import SignalRService from "../../../services/signalR/signalRService";

const ProfileInfo = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const rolname = global.user?.roleName;
  const getUser = Common.getUser();

  // Early return if no user data to prevent null reference errors
  if (!getUser) {
    return null;
  }

  return (
    <DropdownMenu>
      <div className="flex items-center gap-4">
        <Link to="/app/editprofile">
          <img
            src={
              getUser?.image ? Utility.getImagePath(getUser.image) : avatarImg
            }
            alt="My Image"
            className="w-7 h-7 object-cover rounded-lg"
          />
        </Link>

        <DropdownMenuTrigger asChild className=" cursor-pointer">
          <div className=" flex items-center  ">{getUser?.firstName}</div>
        </DropdownMenuTrigger>
      </div>
      <DropdownMenuContent className="w-56 p-0" align="end">
        <DropdownMenuLabel className="flex gap-2 items-center mb-1 p-3">
          <div>
            <div className="text-sm font-medium text-default-800 capitalize ">
              {getUser?.firstName}
            </div>
            <Link
              href="/dashboard"
              className="text-xs text-default-600 hover:text-primary"
            >
              {/* {Common.Utility.getKeyByValue(RoleEnum, user?.roleId)} */}
              {/* {getUser?.roleName} */}
            </Link>
          </div>
        </DropdownMenuLabel>
        {/* <DropdownMenuGroup>
          {[
            {
              name: "profile",
              icon: "heroicons:user",
            },
            {
              name: "Billing",
              icon: "heroicons:megaphone",
            },
            {
              name: "Settings",
              icon: "heroicons:paper-airplane",
            },
            {
              name: "Keyboard shortcuts",
              icon: "heroicons:language",
            },
          ].map((item, index) => (
            <Link
              href="/dashboard"
              key={`info-menu-${index}`}
              className="cursor-pointer"
            >
              <DropdownMenuItem className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
                <Icon icon={item.icon} className="w-4 h-4" />
                {item.name}
              </DropdownMenuItem>
            </Link>
          ))}
        </DropdownMenuGroup> */}
        {/* <DropdownMenuSeparator /> */}
        {/* <DropdownMenuGroup>
          <Link href="/dashboard" className="cursor-pointer">
            <DropdownMenuItem className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
              <Icon icon="heroicons:user-group" className="w-4 h-4" />
              team
            </DropdownMenuItem>
          </Link>
          <DropdownMenuSub>
            <DropdownMenuSubTrigger className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background">
              <Icon icon="heroicons:user-plus" className="w-4 h-4" />
              Invite user
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                {[
                  {
                    name: "email",
                  },
                  {
                    name: "message",
                  },
                  {
                    name: "facebook",
                  },
                ].map((item, index) => (
                  <Link
                    href="/dashboard"
                    key={`message-sub-${index}`}
                    className="cursor-pointer"
                  >
                    <DropdownMenuItem className="text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
                      {item.name}
                    </DropdownMenuItem>
                  </Link>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
          <Link href="/dashboard">
            <DropdownMenuItem className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
              <Icon icon="heroicons:variable" className="w-4 h-4" />
              Github
            </DropdownMenuItem>
          </Link>

          <DropdownMenuSub>
            <DropdownMenuSubTrigger className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
              <Icon icon="heroicons:phone" className="w-4 h-4" />
              Support
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                {[
                  {
                    name: "portal",
                  },
                  {
                    name: "slack",
                  },
                  {
                    name: "whatsapp",
                  },
                ].map((item, index) => (
                  <Link href="/dashboard" key={`message-sub-${index}`}>
                    <DropdownMenuItem className="text-sm font-medium text-default-600 capitalize px-3 py-1.5 dark:hover:bg-background cursor-pointer">
                      {item.name}
                    </DropdownMenuItem>
                  </Link>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
        </DropdownMenuGroup> */}
        <DropdownMenuSeparator className="mb-0 dark:bg-background" />
        <DropdownMenuItem
          onSelect={() => {
            navigate("/app/editprofile", { replace: true });
          }}
          className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize my-1 px-3 dark:hover:bg-background cursor-pointer"
        >
          <Icon icon="heroicons:user" className="w-4 h-4" />
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={async () => {
            try {
              // Disconnect SignalR connection
              const signalRService = SignalRService.getInstance();
              if (signalRService) {
                await signalRService.disconnect();
              }
              
              await Common.clearUser();
              await Common.clearToken();
              // Clear global user reference
              global.user = null;
              // Redirect directly to login page instead of root
              navigate("/login", { replace: true });
            } catch (error) {
              console.error("Error during logout:", error);
              // Force navigation even if clear operations fail
              navigate("/login", { replace: true });
            }
          }}
          className="flex items-center gap-2 text-sm font-medium text-default-600 capitalize my-1 px-3 dark:hover:bg-background cursor-pointer"
        >
          <Icon icon="heroicons:power" className="w-4 h-4" />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
export default ProfileInfo;
